import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import httpV3 from '../factory-api/https-v3'
import appConfig from '../appConfig'

Vue.use(Router)

// 加上再次跳转相同路由  router-link不会报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    // 无效路由自动进入首页
    {
      path: '*',
      redirect: '/'
    },

    // 登录页
    {
      path: '/login',
      name: '',
      meta: {
        title: '登录',
        requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/login/index.vue'], resolve)
      }
    },

    // 工作台路由
    {
      path: '/',
      name: '',
      meta: {
        title: '将来网后台',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/backstage/index.vue'], resolve)
      },
      children: [
        // 引导页路由
        {
          path: '',
          meta: {
            title: '首页',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/home-page/index.vue'], resolve)
          }
        },

        // 春节祝福
        {
          path: 'wish',
          name: '',
          meta: {
            title: '春节祝福',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/wish/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'congratulations'
            },
            {
              path: 'congratulations',
              name: '',
              meta: {
                title: '贺词管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/wish/congratulations/index.vue'
                ], resolve)
              },

              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '贺词列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/wish/congratulations/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '',
                  meta: {
                    title: '贺词详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/wish/congratulations/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'bullet-screen',
              name: '',
              meta: {
                title: '弹幕列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require(['../pages/backstage/wish/bullet-screen.vue'], resolve)
              }
            }
          ]
        },

        // 用户管理
        {
          path: 'user-management',
          name: '',
          meta: {
            title: '用户管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/user-management/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              name: '',
              meta: {
                title: '用户管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/user-management/list.vue'
                ], resolve)
              }
            },
            {
              path: 'details',
              name: '',
              meta: {
                title: '基本信息',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/user-management/children/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  redirect: 'basic'
                },
                {
                  path: 'basic/:id',
                  name: '',
                  meta: {
                    title: '基本信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/user-management/children/basic.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'curriculum/:id',
                  name: '',
                  meta: {
                    title: '基本信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/user-management/children/curriculum-vitae.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'education/:id',
                  name: '',
                  meta: {
                    title: '基本信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/user-management/children/education.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'hobby/:id',
                  name: '',
                  meta: {
                    title: '基本信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/user-management/children/hobby.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'authentication',
              name: '',
              meta: {
                title: '实名认证',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/user-management/authentication/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '认证列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/user-management/authentication/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'examine/:id',
                  name: '',
                  meta: {
                    title: '认证审核',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/user-management/authentication/examine.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },

        // 人员管理
        {
          path: 'personal-management',
          name: '',
          meta: {
            title: '人员管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/personal-management/index.vue'
            ], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              name: '',
              meta: {
                title: '人员列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/personal-management/list.vue'
                ], resolve)
              }
            },
            {
              path: 'create',
              name: '',
              meta: {
                title: '新增人员',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/personal-management/create.vue'
                ], resolve)
              }
            },
            {
              path: 'create/:id',
              name: '',
              meta: {
                title: '人员编辑',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/personal-management/create.vue'
                ], resolve)
              }
            }
          ]
        },
        // 积分管理
        {
          path: 'integral-management',
          name: '',
          meta: {
            title: '积分管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/integral-management/index.vue'
            ], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              name: '',
              meta: {
                title: '活动设置',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/list.vue'
                ], resolve)
              }
            },
            {
              path: 'integral-list',
              name: '',
              meta: {
                title: '积分礼品列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/integral-list.vue'
                ], resolve)
              }
            },
            {
              path: 'user-points',
              name: '',
              meta: {
                title: '用户积分明细',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/user-points.vue'
                ], resolve)
              }
            },
            {
              path: 'order-List',
              name: '',
              meta: {
                title: '订单列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/order-List.vue'
                ], resolve)
              }
            },
            {
              path: 'order-create',
              name: '',
              meta: {
                title: '订单详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/order-create.vue'
                ], resolve)
              }
            },
            {
              path: 'integral-create',
              name: '',
              meta: {
                title: '新增人员',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/integral-create.vue'
                ], resolve)
              }
            },
            {
              path: 'integral-create/:id',
              name: '',
              meta: {
                title: '人员编辑',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/integral-create.vue'
                ], resolve)
              }
            },
            {
              path: 'create',
              name: '',
              meta: {
                title: '新增人员',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/create.vue'
                ], resolve)
              }
            },
            {
              path: 'create/:id',
              name: '',
              meta: {
                title: '人员编辑',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/integral-management/create.vue'
                ], resolve)
              }
            }
          ]
        },
        // 企业管理
        {
          path: 'enterprise-management',
          meta: {
            title: '企业管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/enterprise-management/index.vue'
            ], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'enterprise-list'
            },

            {
              path: 'enterprise-list',
              name: '',
              meta: {
                title: '企业列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-management/enterprise-list/index.vue'
                ], resolve)
              }
            },
            {
              path: 'enterprise-create',
              name: '',
              meta: {
                title: '新增企业',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-management/enterprise-create/index.vue'
                ], resolve)
              }
            },

            {
              path: 'enterprise-super',
              name: '',
              meta: {
                title: '超管审核',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-management/enterprise-super/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '申请列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-super/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '',
                  meta: {
                    title: '申请详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-super/details.vue'
                    ], resolve)
                  }
                }
              ]
            },

            {
              path: 'enterprise-examine',
              name: '',
              meta: {
                title: '企业审核',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-management/enterprise-examine/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '申请列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-examine/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '',
                  meta: {
                    title: '申请详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-examine/details.vue'
                    ], resolve)
                  }
                }
              ]
            },

            {
              path: 'enterprise-member',
              name: '',
              meta: {
                title: '企业员工审核',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-management/enterprise-member/index.vue'
                ], resolve)
              }
            },

            {
              path: 'enterprise-info/:id',
              name: '',
              meta: {
                title: '企业信息',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-management/enterprise-info/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'enterprise-information'
                },

                {
                  path: 'essential-information',
                  name: '',
                  meta: {
                    title: '基本信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-info/children/essential-information.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'business-information',
                  name: '',
                  meta: {
                    title: '工商信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-info/children/business-information.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'company-structure',
                  name: '',
                  meta: {
                    title: '公司架构',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-info/children/company-structure.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'qualification-information',
                  name: '',
                  meta: {
                    title: '资质信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-management/enterprise-info/children/qualification-information.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },

        // 企业配置
        {
          path: 'enterprise-configure',
          meta: {
            title: '企业配置',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/enterprise-configure/index.vue'
            ], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'organizational-structure'
            },

            {
              path: 'organizational-structure',
              name: '',
              meta: {
                title: '组织架构',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-configure/organizational-structure/index.vue'
                ], resolve)
              }
            },
            {
              path: 'role-management',
              name: '',
              meta: {
                title: '角色管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/enterprise-configure/role-management/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '角色列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-configure/role-management/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '角色新增',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-configure/role-management/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create/:id',
                  name: '',
                  meta: {
                    title: '角色编辑',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/enterprise-configure/role-management/create.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },

        // 新闻中心
        {
          path: 'article',
          meta: {
            title: '新闻中心',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/article-center/index.vue'], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'statistics'
            },
            {
              path: 'statistics',
              name: '',
              meta: {
                title: '新闻统计',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/statistics/index.vue'
                ], resolve)
              }
            },
            {
              path: 'category',
              name: '',
              meta: {
                title: '分类列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/category/index.vue'
                ], resolve)
              }
            },
            {
              path: 'label',
              name: '',
              meta: {
                title: '标签列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/label/index.vue'
                ], resolve)
              }
            },
            {
              path: 'drafts',
              name: '',
              meta: {
                title: '草稿箱列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/drafts/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '草稿箱列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-center/drafts/list.vue'
                    ], resolve)
                  }
                },

                {
                  path: 'detail/:id',
                  name: '',
                  meta: {
                    title: '详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-center/drafts/detail.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'article-list',
              name: '',
              meta: {
                title: '新闻列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/article-list/list/index.vue'
                ], resolve)
              }
            },
            {
              path: 'examine',
              name: '',
              meta: {
                title: '新闻审核',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/examine/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '新闻审核',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-center/examine/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '',
                  meta: {
                    title: '审核详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-center/examine/examine.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'modify/:id',
              name: '',
              meta: {
                title: '新闻编辑',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/article-list/modify/index.vue'
                ], resolve)
              }
            },
            {
              path: 'comment',
              name: '',
              meta: {
                title: '评论列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/comment/index.vue'
                ], resolve)
              }
            },

            {
              path: 'details/:id',
              name: '',
              meta: {
                title: '新闻详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/article-list/details/index.vue'
                ], resolve)
              }
            },
            {
              path: 'create',
              name: '',
              meta: {
                title: '创建新闻',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-center/article-list/create/index.vue'
                ], resolve)
              }
            }
          ]
        },

        {
          path: 'forum',
          meta: {
            title: '论坛管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/forum-management/index.vue'], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'statistics'
            },
            {
              path: 'statistics',
              name: '论坛统计',
              meta: {
                title: '论坛统计',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/statistics.vue'
                ], resolve)
              }
            },
            {
              path: 'industry-elite',
              name: '',
              meta: {
                title: '行业精英',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/industry-elite/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '行业精英列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/industry-elite/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增大咖',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/industry-elite/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'detail/:id',
                  name: '',
                  meta: {
                    title: '大咖详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/industry-elite/detail.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'examine-list',
                  name: '',
                  meta: {
                    title: '审核大咖列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/industry-elite/examine-list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'examine-detail/:id',
                  name: '',
                  meta: {
                    title: '审核大咖列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/industry-elite/examine-detail.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'topic',
              name: '',
              meta: {
                title: '话题',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/topic/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '话题列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/topic/topic.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增话题',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/topic/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '编辑话题',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/topic/modify.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'live',
              name: '',
              meta: {
                title: '直播',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/live/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '直播列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/live/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增直播',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/live/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '编辑直播',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/live/modify.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'environmental',
              name: '',
              meta: {
                title: '环保学堂',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/environmental-protection/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '环保学堂列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/environmental-protection/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增环保学堂',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/environmental-protection/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '编辑环保学堂',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/environmental-protection/modify.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'examine-list',
                  name: '',
                  meta: {
                    title: '审核环保学堂',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/environmental-protection/examine-list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'examine-detail/:id',
                  name: '',
                  meta: {
                    title: '环保学堂详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/environmental-protection/examine-detail.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'data-list/:id',
                  name: '',
                  meta: {
                    title: '数据列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/environmental-protection/data-list.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'brand',
              name: '',
              meta: {
                title: '品牌列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/brand/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '品牌列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/brand/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增品牌',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/brand/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '修改品牌',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/brand/modify.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'modular',
              name: '',
              meta: {
                title: '板块列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/modular/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '板块列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/modular/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增板块',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/modular/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '修改板块',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/modular/modify.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'course',
              name: '',
              meta: {
                title: '课程',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/course/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '课程列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/course/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增课程',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/course/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '编辑课程',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/course/modify.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'library',
              name: '',
              meta: {
                title: '技术文库',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/library/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '文库列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/library/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增文库',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/library/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'detail/:id',
                  name: '',
                  meta: {
                    title: '文库详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/library/detail.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modify/:id',
                  name: '',
                  meta: {
                    title: '编辑文库',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/library/modify.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'data-list/:id',
                  name: '',
                  meta: {
                    title: '数据列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/library/data-list.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'library-category',
              name: '文库分类',
              meta: {
                title: '文库分类',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/library-category/index.vue'
                ], resolve)
              }
            },
            {
              path: 'industry-category',
              name: '智库分类',
              meta: {
                title: '智库分类',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/industry-category/index.vue'
                ], resolve)
              }
            },
            {
              path: 'course-category',
              name: '分类列表',
              meta: {
                title: '分类列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/course-category/index.vue'
                ], resolve)
              }
            },
            {
              path: 'label',
              name: '标签列表',
              meta: {
                title: '标签列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/label/index.vue'
                ], resolve)
              }
            },
            {
              path: 'comment',
              name: '评论列表',
              meta: {
                title: '评论列表',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/comment/index.vue'
                ], resolve)
              }
            },
            {
              path: 'picture',
              name: '',
              meta: {
                title: '精彩图集',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/forum-management/picture/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  name: '',
                  meta: {
                    title: '精彩图集',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/forum-management/picture/list.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },

        {
          path: 'shop-management',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '商铺管理'
          },
          component: resolve => {
            require(['../pages/backstage/shop-management/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'list'
            },
            {
              path: 'list',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '商铺管理'
              },
              component: resolve => {
                require([
                  '../pages/backstage/shop-management/list.vue'
                ], resolve)
              }
            },
            {
              path: 'details/:id',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '商铺信息'
              },
              component: resolve => {
                require([
                  '../pages/backstage/shop-management/details.vue'
                ], resolve)
              }
            },
            {
              path: 'renew',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '续费提醒'
              },
              component: resolve => {
                require([
                  '../pages/backstage/shop-management/renew.vue'
                ], resolve)
              }
            },
            {
              path: 'cost',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '商铺费用'
              },
              component: resolve => {
                require([
                  '../pages/backstage/shop-management/cost.vue'
                ], resolve)
              }
            }
          ]
        },

        {
          path: 'safe-center',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '账号与安全'
          },
          component: resolve => {
            require(['../pages/backstage/safe-center/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'password'
            },
            {
              path: 'password',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '修改密码'
              },
              component: resolve => {
                require([
                  '../pages/backstage/safe-center/password.vue'
                ], resolve)
              }
            }
          ]
        },

        {
          path: 'website-center',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '将来链站'
          },
          component: resolve => {
            require(['../pages/backstage/website-center/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'statistics'
            },
            {
              path: 'statistics',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '将来链站统计'
              },
              component: resolve => {
                require([
                  '../pages/backstage/website-center/statistics.vue'
                ], resolve)
              }
            },
            {
              path: 'list',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '将来链站列表'
              },
              component: resolve => {
                require([
                  '../pages/backstage/website-center/list.vue'
                ], resolve)
              }
            }
          ]
        },

        // 平台公告
        {
          path: 'operate',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '网站运营'
          },
          component: resolve => {
            require(['../pages/backstage/operate/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'advertisement'
            },
            {
              path: 'advertisement',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '广告位管理'
              },
              component: resolve => {
                require([
                  '../pages/backstage/operate/advertisement/list.vue'
                ], resolve)
              }
            },
            {
              path: 'platform-announcement',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '平台公告'
              },
              component: resolve => {
                require([
                  '../pages/backstage/operate/platform-announcement/list.vue'
                ], resolve)
              }
            }
          ]
        },

        // 天大路由
        {
          path: 'tiandaCollege',
          name: 'tiandaCollege',
          meta: {
            title: '天大学院',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/tiandaCollege/index.vue'], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'my-site'
            },

            // 天大首页
            {
              path: 'my-site',
              name: '',
              meta: {
                title: '',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/tiandaCollege/my-site/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'tianda-enterprise'
                },
                // 天大企业
                {
                  path: 'tianda-enterprise',
                  name: 'tianda-enterprise',
                  meta: {
                    title: '天大企业',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/tiandaCollege/my-site/tianda-enterprise.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'modifytianda',
                  name: 'modifytianda',
                  meta: {
                    title: '天大介绍',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/tiandaCollege/my-site/modifytianda.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'recruit',
                  name: 'recruit',
                  meta: {
                    title: '招生信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/tiandaCollege/my-site/recruit.vue'
                    ], resolve)
                  }
                },
                // 天大课堂
                {
                  path: 'tiandaSchool',
                  name: 'tiandaSchool',
                  meta: {
                    title: '天大课堂',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/tiandaCollege/my-site/tiandaKetang.vue'
                    ], resolve)
                  }
                },
                // 天大企业添加
                {
                  path: 'tiandaEnterprise',
                  name: 'tiandaEnterprise',
                  meta: {
                    title: '天大企业添加',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/tiandaCollege/my-site/tiandaEnterprise.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'tiandaClassroom',
                  name: 'tiandaClassroom',
                  meta: {
                    title: '学员新增',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/tiandaCollege/my-site/tiandaClassroom.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },

        {
          path: 'future-star',
          meta: {
            title: '',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/future-star/index.vue'], resolve)
          },
          children: [
            // 天大首页
            {
              path: 'my-site',
              name: '',
              meta: {
                title: '',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/future-star/my-site/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'futureStar'
                },
                {
                  path: 'futureStar',
                  name: 'futureStar',
                  meta: {
                    title: '将来之星',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/future-star/my-site/futureStar.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'increase-future',
                  name: 'increase-future',
                  meta: {
                    title: '新增将来之星',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/future-star/my-site/increase-future.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },
        {
          path: 'association',
          name: 'association',
          meta: {
            title: '',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/association/index.vue'], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'my-site'
            },

            // 膜协会
            {
              path: 'my-site',
              name: '',
              meta: {
                title: '膜协会',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/association/my-site/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'associationList'
                },
                // 膜协会添加
                {
                  path: 'membrane-association',
                  name: 'membrane-association',
                  meta: {
                    title: '膜协会添加',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/association/my-site/membrane-association.vue'
                    ], resolve)
                  }
                },
                // 膜协会
                {
                  path: 'associationList',
                  name: 'associationList',
                  meta: {
                    title: '膜协会',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/association/my-site/associationList.vue'
                    ], resolve)
                  }
                },
                // 膜协会常驻嘉宾
                {
                  path: 'associationStar',
                  name: 'associationStar',
                  meta: {
                    title: '膜协会常驻嘉宾',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/association/my-site/associationStar.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },
        // {
        //   path: 'help-center',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '帮助中心'
        //   },
        //   component: resolve => {
        //     require(['../pages/backstage/help-center/index.vue'], resolve)
        //   },
        //   children: [
        //     {
        //       path: '',
        //       redirect: 'list'
        //     },
        //     {
        //       path: 'list',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '问题列表'
        //       },
        //       component: resolve => {
        //         require(['../pages/backstage/help-center/list.vue'], resolve)
        //       }
        //     },
        //     {
        //       path: 'class',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '栏目列表'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage/help-center/class/list.vue'
        //         ], resolve)
        //       }
        //     },
        //     {
        //       path: 'create',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '新增问题'
        //       },
        //       component: resolve => {
        //         require(['../pages/backstage/help-center/create.vue'], resolve)
        //       }
        //     },
        //     {
        //       path: 'modify/:id',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '编辑问题'
        //       },
        //       component: resolve => {
        //         require(['../pages/backstage/help-center/modify.vue'], resolve)
        //       }
        //     }
        //   ]
        // },

        // 商品管理
        {
          path: 'commodity-manage',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '商品管理'
          },
          component: resolve => {
            require(['../pages/backstage/commodity-manage/index.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: 'commodity-center'
            },

            {
              path: 'commodity-center',
              meta: {
                title: '商品管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/commodity-center/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    title: '商品列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-center/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  meta: {
                    title: '商品详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-center/details.vue'
                    ], resolve)
                  }
                }
              ]
            },

            {
              path: 'commodity-template',
              meta: {
                title: '商品模板',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/commodity-template/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    title: '模板列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-template/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  meta: {
                    title: '新增模板',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-template/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  meta: {
                    title: '编辑模板',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-template/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  meta: {
                    title: '模板详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-template/details.vue'
                    ], resolve)
                  }
                }
              ]
            },

            // 品牌管理
            {
              path: 'brand',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '品牌管理'
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/brand/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '品牌列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/brand/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '品牌详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/brand/details.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '新增品牌'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/brand/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '编辑品牌'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/brand/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'history/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '品牌历史'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/brand/history.vue'
                    ], resolve)
                  }
                }
              ]
            },

            // 商品分类管理
            {
              path: 'commodity-category',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '商品分类管理'
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/commodity-category/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '商品分类列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-category/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'secondary-list/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '商品分类下级分类'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-category/children/secondary-list.vue'
                    ], resolve)
                  }
                },
                {
                  // 规格模板列表
                  path: 'specification-template/:pid/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '规格模板列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-category/children/specification-template.vue'
                    ], resolve)
                  }
                },
                {
                  // 新增规格模板
                  path: 'create-specification/create/:pid/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '新增规格模板'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-category/children/create-specification.vue'
                    ], resolve)
                  }
                },
                {
                  // 编辑规格模板
                  path: 'create-specification/edit/:pid/:id/:sid',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '编辑规格模板'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/commodity-category/children/create-specification.vue'
                    ], resolve)
                  }
                }
              ]
            },

            // 规格模板
            {
              path: 'spec-template',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '规格模板'
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/spec-template/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '规格模板列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/spec-template/list.vue'
                    ], resolve)
                  }
                },
                {
                  // 新增规格模板
                  path: 'create',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '新增规格模板'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/spec-template/create.vue'
                    ], resolve)
                  }
                },
                {
                  // 编辑规格模板
                  path: 'edit/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '编辑规格模板'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/commodity-manage/spec-template/create.vue'
                    ], resolve)
                  }
                }
              ]
            },

            // 品牌标签
            {
              path: 'brand-label',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '品牌标签'
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/brand-label/index.vue'
                ], resolve)
              }
            },
            // 单位管理
            {
              path: 'units',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '单位管理'
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/units/index.vue'
                ], resolve)
              }
            },
            // 单位类型
            {
              path: 'units-category',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '单位类型'
              },
              component: resolve => {
                require([
                  '../pages/backstage/commodity-manage/units-category/index.vue'
                ], resolve)
              }
            }
          ]
        },

        // 推荐管理
        {
          path: 'recommend-manage',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '推荐管理'
          },
          component: resolve => {
            require(['../pages/backstage/recommend-manage/index.vue'], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'single-product-category'
            },

            {
              path: 'single-product-category',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '分类管理 - 单品推荐'
              },
              component: resolve => {
                require([
                  '../pages/backstage/recommend-manage/single-product-category/index.vue'
                ], resolve)
              }
            },
            {
              path: 'single-product-brand',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '品牌管理 - 单品推荐'
              },
              component: resolve => {
                require([
                  '../pages/backstage/recommend-manage/single-product-brand/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '品牌列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/recommend-manage/single-product-brand/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:brand_id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '品牌详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/recommend-manage/single-product-brand/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'flagship-store',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '旗舰店推荐'
              },
              component: resolve => {
                require([
                  '../pages/backstage/recommend-manage/flagship-store/index.vue'
                ], resolve)
              }
            },

            {
              path: 'home-page-category',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '首页类目推荐'
              },
              component: resolve => {
                require([
                  '../pages/backstage/recommend-manage/home-page-category/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '类目列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/recommend-manage/home-page-category/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '类目详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/recommend-manage/home-page-category/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'mall-brand',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '商城中心品牌专区推荐'
              },
              component: resolve => {
                require([
                  '../pages/backstage/recommend-manage/mall-brand/index.vue'
                ], resolve)
              }
            },
            {
              path: 'expert',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '商城中心 一级分类页 专家视角'
              },
              component: resolve => {
                require([
                  '../pages/backstage/recommend-manage/expert/index.vue'
                ], resolve)
              }
            }
          ]
        },

        // 名片管理（需要指定后台权限）
        {
          path: 'visiting-card-manage',
          meta: {
            title: '名片管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/visiting-card-manage/index.vue'
            ], resolve)
          },
          children: [
            // 默认路径
            {
              path: '',
              redirect: 'customized'
            },
            {
              path: 'visiting-card',
              meta: {
                title: '名片商品',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/visiting-card-manage/visiting-card/index.vue'
                ], resolve)
              },
              children: [
                // 默认路径
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    title: '名片列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/visiting-card/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  meta: {
                    title: '名片上传',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/visiting-card/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  meta: {
                    title: '名片编辑',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/visiting-card/create.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'order',
              meta: {
                title: '名片订单',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/visiting-card-manage/order/index.vue'
                ], resolve)
              },
              children: [
                // 默认路径
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    title: '订单列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/order/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  meta: {
                    title: '订单详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/order/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'customized',
              meta: {
                title: '名片定制',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/visiting-card-manage/customized/index.vue'
                ], resolve)
              },
              children: [
                // 默认路径
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  meta: {
                    title: '名片定制列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/customized/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id/:userId',
                  meta: {
                    title: '名片定制详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/visiting-card-manage/customized/details.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },

        // 配置中台管理员权限
        // {
        //   path: 'configure-permissions',
        //   meta: {
        //     title: '中台管理者',
        //     requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //   },
        //   component: resolve => {
        //     require([
        //       '../pages/backstage/configure-permissions/index.vue'
        //     ], resolve)
        //   },
        //   children: [
        //     {
        //       path: '',
        //       redirect: 'permissions'
        //     },
        //     {
        //       path: 'permissions',
        //       meta: {
        //         title: '中台管理者',
        //         requireAuth: true
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage/configure-permissions/permissions.vue'
        //         ], resolve)
        //       }
        //     }
        //   ]
        // },

        // 竞价池管理
        {
          path: 'requirement-pool-manage',
          name: '',
          meta: {
            title: '竞价池管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/requirement-pool-manage/index.vue'
            ], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'expenses'
            },

            {
              path: 'expenses',
              name: '',
              meta: {
                title: '费用设置',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/requirement-pool-manage/expenses.vue'
                ], resolve)
              }
            }
          ]
        },

        // ################################### 二版路由 start ####################################################

        // 文章管理
        // {
        //   path: 'article-manage',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '文章管理'
        //   },
        //   component: resolve => {
        //     require([
        //       '../pages/backstage-v2/article-manage/index.vue'
        //     ], resolve)
        //   },
        //   children: [
        //     {
        //       path: 'category',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '类目管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/article-manage/category/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '类目列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/category/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'subcategory',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '类目维护'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/category/subcategory.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       path: 'article',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '文章信息'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/article-manage/article/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '文章列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/article/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '文章详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/article/details.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'create',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '新增文章'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/article/create.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       path: 'auditing',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '审核管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/article-manage/auditing/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '文章列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/auditing/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '文章详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/article-manage/auditing/details.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 品牌管理
        // {
        //   path: 'brand-manage',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '品牌管理'
        //   },
        //   component: resolve => {
        //     require(['../pages/backstage-v2/brand-manage/index.vue'], resolve)
        //   },
        //   children: [
        //     {
        //       path: 'brand',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '品牌信息'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/brand-manage/brand/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '品牌列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/brand-manage/brand/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '品牌详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/brand-manage/brand/details.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'create',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '新增品牌'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/brand-manage/brand/create.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 品类管理
        // {
        //   path: 'category-manage',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '品类管理'
        //   },
        //   component: resolve => {
        //     require([
        //       '../pages/backstage-v2/category-manage/index.vue'
        //     ], resolve)
        //   },
        //   children: [
        //     {
        //       path: 'backstage',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '后台品类管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/category-manage/backstage/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '后台品类信息'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/category-manage/backstage/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'subcategory',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '后台品类维护'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/category-manage/backstage/subcategory.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           // 筛选条件编辑
        //           path: 'screening-condition',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '筛选条件编辑'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/category-manage/backstage/screening-condition.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 帮助中心
        {
          path: 'help-center-manage',
          name: '',
          meta: {
            title: '帮助中心管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/help-center-manage/index.vue'
            ], resolve)
          },
          children: [
            {
              path: 'question',
              name: '',
              meta: {
                title: '问题管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/help-center-manage/question/index.vue'
                ], resolve)
              },

              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '问题列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/help-center-manage/question/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '创建问题',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/help-center-manage/question/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  name: '',
                  meta: {
                    title: '编辑问题',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/help-center-manage/question/create.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'column',
              name: '',
              meta: {
                title: '栏目管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/help-center-manage/column/index.vue'
                ], resolve)
              },

              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '栏目列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/help-center-manage/column/list.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },
        // 知识论坛
        // {
        //   path: 'knowledge-forum',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '知识论坛'
        //   },
        //   component: resolve => {
        //     require([
        //       '../pages/backstage-v2/knowledge-forum/index.vue'
        //     ], resolve)
        //   },
        //   children: [
        //     {
        //       path: 'homepage',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '知识论坛统计'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/knowledge-forum/homepage/index.vue'
        //         ], resolve)
        //       }
        //     },
        //     {
        //       path: 'category',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '分类管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/knowledge-forum/category/index.vue'
        //         ], resolve)
        //       }
        //     },
        //     {
        //       path: 'label',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '标签管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/knowledge-forum/label/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '标签列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/label/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'list/:id',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '标签详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/label/children/index.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       path: 'forum',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '论坛管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/knowledge-forum/forum/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '列表页'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/forum/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details/:id',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '论坛管理'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/forum/details.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'examine/:id',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '审核页面'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/forum/examine.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       path: 'comment',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '评论管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/knowledge-forum/comment/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '评论管理'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/comment/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'list/:id',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '评论管理'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/knowledge-forum/comment/chldren/index.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 文库管理
        // {
        //   path: 'library-manage',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '文库管理'
        //   },
        //   component: resolve => {
        //     require([
        //       '../pages/backstage-v2/library-manage/index.vue'
        //     ], resolve)
        //   },
        //   children: [
        //     {
        //       path: 'category',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '类目管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/library-manage/category/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '类目列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/library-manage/category/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'subcategory',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '类目维护'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/library-manage/category/subcategory.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       path: 'library',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '文库信息'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/library-manage/library/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '文库列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/library-manage/library/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '文库详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/library-manage/library/details.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'create',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '新增文库'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/library-manage/library/create.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 网站运营
        // {
        //   path: 'operate-settings',
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: '网站运营'
        //   },
        //   component: resolve => {
        //     require([
        //       '../pages/backstage-v2/operate-settings/index.vue'
        //     ], resolve)
        //   },
        //   children: [
        //     {
        //       path: 'measurement-units',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '计量单位'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/operate-settings/measurement-units/index.vue'
        //         ], resolve)
        //       }
        //     },
        //     {
        //       path: 'abvent-position',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '广告位管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/operate-settings/abvent-position/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '广告位列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/operate-settings/abvent-position/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details/:id',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '广告位详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/operate-settings/abvent-position/details.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     },
        //     {
        //       path: 'abvent',
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: '广告图管理'
        //       },
        //       component: resolve => {
        //         require([
        //           '../pages/backstage-v2/operate-settings/abvent/index.vue'
        //         ], resolve)
        //       },
        //       children: [
        //         {
        //           path: '',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '广告图列表'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/operate-settings/abvent/list.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'create',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '广告图新增'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/operate-settings/abvent/create.vue'
        //             ], resolve)
        //           }
        //         },
        //         {
        //           path: 'details/:id',
        //           meta: {
        //             requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //             title: '广告图详情'
        //           },
        //           component: resolve => {
        //             require([
        //               '../pages/backstage-v2/operate-settings/abvent/details.vue'
        //             ], resolve)
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 商品管理
        // {
        //   path: "product-manage",
        //   meta: {
        //     requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //     title: "商品管理"
        //   },
        //   component: resolve => {
        //     require([
        //       "../pages/backstage-v2/product-manage/index.vue"
        //     ], resolve);
        //   },
        //   children: [
        //     {
        //       path: "product",
        //       meta: {
        //         requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        //         title: "商品信息"
        //       },
        //       component: resolve => {
        //         require([
        //           "../pages/backstage-v2/product-manage/product/index.vue"
        //         ], resolve);
        //       },
        //       children: [
        //         {
        //           path: "",
        //           meta: {
        //             title: "商品信息",
        //             requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //           },
        //           component: resolve => {
        //             require([
        //               "../pages/backstage-v2/product-manage/product/list.vue"
        //             ], resolve);
        //           }
        //         },
        //         {
        //           path: "commodity-add",
        //           name: "新增商品",
        //           meta: {
        //             title: "新增商品",
        //             requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //           },
        //           component: resolve => {
        //             require([
        //               "../pages/backstage-v2/product-manage/product/create.vue"
        //             ], resolve);
        //           }
        //         },
        //         {
        //           path: "commodity-edit",
        //           name: "编辑商品",
        //           meta: {
        //             title: "编辑商品",
        //             requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //           },
        //           component: resolve => {
        //             require([
        //               "../pages/backstage-v2/product-manage/product/details.vue"
        //             ], resolve);
        //           }
        //         }
        //       ]
        //     }
        //   ]
        // },

        // 单品推荐
        /* {
          path: 'recommend-single-product',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            title: '单品推荐管理'
          },
          component: resolve => {
            require(['../pages/backstage-v2/recommend-single-product/index.vue'], resolve)
          },
          children: [
            {
              path: 'category',
              meta: {
                requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                title: '推荐分类管理'
              },
              component: resolve => {
                require(['../pages/backstage-v2/recommend-single-product/category/index.vue'], resolve)
              }
            },
            {
              path: 'brand',
              meta: {
                requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                title: '推荐品牌管理'
              },
              component: resolve => {
                require(['../pages/backstage-v2/recommend-single-product/brand/index.vue'], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                    title: '推荐品牌列表'
                  },
                  component: resolve => {
                    require(['../pages/backstage-v2/recommend-single-product/brand/list.vue'], resolve)
                  }
                },
                {
                  path: 'details/:brand_id',
                  meta: {
                    requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                    title: '推荐品牌详情'
                  },
                  component: resolve => {
                    require(['../pages/backstage-v2/recommend-single-product/brand/details.vue'], resolve)
                  }
                },
              ]
            },
            {
              path: 'outstanding',
              meta: {
                requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                title: '优推品牌管理'
              },
              component: resolve => {
                require(['../pages/backstage-v2/recommend-single-product/brand/index.vue'], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
                    title: '推荐品牌列表'
                  },
                  component: resolve => {
                    require(['../pages/backstage-v2/recommend-single-product/brand/outstanding.vue'], resolve)
                  }
                }
              ]
            },
          ]
        }, */

        // 投票活动管理
        {
          path: 'vote-manage',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: '投票活动管理'
          },
          component: resolve => {
            require(['../pages/backstage-v2/vote-manage/index.vue'], resolve)
          },
          children: [
            {
              path: 'statistics',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '统计信息'
              },
              component: resolve => {
                require([
                  '../pages/backstage-v2/vote-manage/statistics/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    title: '总体统计信息',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/vote-manage/statistics/total.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  meta: {
                    title: '统计详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/vote-manage/statistics/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'daily-record',
              meta: {
                title: '投票日志',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage-v2/vote-manage/statistics/daily-record.vue'
                ], resolve)
              }
            }
          ]
        },
        // 环博会管理（展会管理）
        {
          path: 'exhibition-manage',
          name: '',
          meta: {
            title: '展会管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            // require(['../pages/backstage/exhibition-manage/index.vue'], resolve)
            require([
              '../pages/backstage/exhibition-manage/index.vue'
            ], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'exhibition-management'
            },
            // 展会管理
            {
              path: 'exhibition-management',
              name: '',
              meta: {
                title: '展会管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/exhibition-manage/exhibition-management.vue'
                ], resolve)
              }
            },
            // 精彩图集
            {
              path: 'exhibition-highlights',
              name: '',
              meta: {
                title: '精彩图集',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/exhibition-manage/exhibition-highlights.vue'
                ], resolve)
              }
            },
            // 展馆管理
            {
              path: 'exhibition-hall',
              name: '',
              meta: {
                title: '展馆管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/exhibition-manage/exhibition-hall.vue'
                ], resolve)
              }
            },
            // 展会企业管理
            {
              path: 'exhibition-company',
              name: '',
              meta: {
                title: '企业管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/exhibition-manage/exhibition-company.vue'
                ], resolve)
              }
            },
            // 展会新闻管理
            {
              path: 'exhibition-news',
              name: '',
              meta: {
                title: '新闻管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/exhibition-manage/exhibition-news/index.vue'
                ], resolve)
              },
              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },
                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '新闻列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/exhibition-manage/exhibition-news/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新增新闻',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/exhibition-manage/exhibition-news/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  name: '',
                  meta: {
                    title: '编辑新闻',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/exhibition-manage/exhibition-news/create.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },
        // 广告管理
        {
          path: 'advertising-manage',
          meta: {
            title: '广告管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/advertising-manage/index.vue'
            ], resolve)
          },
          children: [
            // 默认路径
            {
              path: '',
              redirect: 'statistics'
            },
            {
              path: 'statistics',
              meta: {
                title: '广告统计',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/advertising-manage/statistics.vue'
                ], resolve)
              }
            },
            {
              path: 'position',
              meta: {
                title: '广告位管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/advertising-manage/position.vue'
                ], resolve)
              }
            },
            {
              path: 'list',
              meta: {
                title: '广告图管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/advertising-manage/list.vue'
                ], resolve)
              },
              children: [
                {
                  path: ':cid',
                  meta: {
                    title: '',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  }
                }
              ]
            }
          ]
        },
        // 会员管理
        {
          path: 'membership-manage',
          meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            title: ''
          },
          component: resolve => {
            require([
              '../pages/backstage-v2/membership-manage/index.vue'
            ], resolve)
          },
          children: [
            {
              path: 'member',
              meta: {
                requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                title: '会员管理'
              },
              component: resolve => {
                require([
                  '../pages/backstage-v2/membership-manage/member/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '会员列表'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/member/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'member-details',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '会员详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/member/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'visit',
              meta: {
                title: '走访管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage-v2/membership-manage/visit/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    title: '走访列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/visit/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'visit-details',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '列表详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/visit/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'item',
              meta: {
                title: '项目管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage-v2/membership-manage/item/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    title: '项目列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/item/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'item-details',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '项目详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/item/details.vue'
                    ], resolve)
                  }
                }
              ]
            },
            {
              path: 'serve',
              meta: {
                title: '服务管理',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage-v2/membership-manage/serve/index.vue'
                ], resolve)
              },
              children: [
                {
                  path: '',
                  meta: {
                    title: '服务列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/serve/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'serve-details',
                  meta: {
                    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
                    title: '列表详情'
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage-v2/membership-manage/serve/details.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        },
        // 会员列表
        {
          path: 'member-manage',
          name: '',
          meta: {
            title: '会员列表',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/member-manage/index.vue'], resolve)
          }
        },
        // 平台公告
        {
          path: 'platform-announcement-manage',
          name: '',
          meta: {
            title: '平台公告',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require([
              '../pages/backstage/platform-announcement-manage/index.vue'
            ], resolve)
          }
        },
        // 新闻管理
        {
          path: 'article-manage',
          name: '',
          meta: {
            title: '新闻管理',
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          },
          component: resolve => {
            require(['../pages/backstage/article-manage/index.vue'], resolve)
          },
          children: [
            // 默认跳转
            {
              path: '',
              redirect: 'article'
            },

            // 新闻信息
            {
              path: 'article',
              name: '',
              meta: {
                title: '新闻信息',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-manage/article/index.vue'
                ], resolve)
              },

              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '新闻列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/article/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '',
                  meta: {
                    title: '新闻详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/article/details.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'create',
                  name: '',
                  meta: {
                    title: '新闻发布',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/article/create.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  name: '',
                  meta: {
                    title: '新闻编辑',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/article/create.vue'
                    ], resolve)
                  }
                }
              ]
            },

            // 草稿箱
            {
              path: 'drafts',
              name: '',
              meta: {
                title: '草稿信息',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
              },
              component: resolve => {
                require([
                  '../pages/backstage/article-manage/drafts/index.vue'
                ], resolve)
              },

              children: [
                // 默认跳转
                {
                  path: '',
                  redirect: 'list'
                },

                {
                  path: 'list',
                  name: '',
                  meta: {
                    title: '草稿列表',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/drafts/list.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'details/:id',
                  name: '',
                  meta: {
                    title: '草稿详情',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/drafts/details.vue'
                    ], resolve)
                  }
                },
                {
                  path: 'edit/:id',
                  name: '',
                  meta: {
                    title: '草稿编辑',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                  },
                  component: resolve => {
                    require([
                      '../pages/backstage/article-manage/drafts/create.vue'
                    ], resolve)
                  }
                }
              ]
            }
          ]
        }

        // ############################## 二版路由 end #########################################################
      ]
    },

    // 中转页面路由（默认为顶部切换所属企业时使用）
    {
      path: '/transit',
      name: '跳转中',
      meta: {
        title: '跳转中',
        requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
      },
      component: resolve => {
        require(['../pages/transit/index.vue'], resolve)
      }
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

// 设置Cookie
let setCookie = (c_name, value, expiredays) => {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    c_name +
    '=' +
    escape(value) +
    ';domain=' +
    appConfig.API.DOMAIN_NAME +
    (expiredays === null ? '' : ';expires=' + exdate.toGMTString()) +
    ';path=/'
}
let delCookie = name => {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval !== null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}
// 获取Cookie
let getCookie = name => {
  let arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) {
    return arr[2]
  } else {
    return null
  }
}

// 格式化用户信息
let userFormat = (userInfo, route = '') => {
  if (userInfo) {
    // 初始化用户名
    if (userInfo.realName) {
      userInfo.name = userInfo.realName
    } else if (userInfo.nickName) {
      userInfo.name = userInfo.nickName
    } else {
      userInfo.name = userInfo.loginName
    }
    userInfo.id = userInfo.userId
    // 初始化手机号
    userInfo.phone = userInfo.mobilePhone
    // 初始化头像
    userInfo.icon = userInfo.headIconUrl

    store.commit('updateUserInfo', userInfo)
    setCookie('userInfo', JSON.stringify(userInfo))
  } else {
    console.log('获取用户信息为空')
    // 是否需要登录
    if (route && route.meta.requireAuth) {
      // 跳转登录页
      window.location.href = '/login?redirect=' + route.path
    } else {
      // window.localStorage.setItem('userInfo', "")
      delCookie('userInfo')
      store.commit('updateUserInfo', '')
    }
  }
}

router.beforeEach((to, from, next) => {
  // 获取token信息
  let token = getCookie('token')
  if (token) {
    token = unescape(token)
    store.commit('updateToken', token)
  } else {
    setCookie('token', '')
    store.commit('updateToken', '')
  }

  // 获取用户信息
  // let userInfo = window.localStorage.getItem('userInfo')
  let userInfo = getCookie('userInfo')
  if (userInfo) {
    // 转换特殊符号
    userInfo = unescape(userInfo)
    // 转换字符串为变量
    userInfo = JSON.parse(userInfo)
  }
  userFormat(userInfo)

  // console.log(to)
  // 初始化浏览器窗口标题
  let title = []
  if (to.matched.length > 1) {
    let arr = to.matched
    arr.forEach(item => {
      if (item.meta.title) {
        title.push(item.meta.title)
      }
    })
  } else {
    title.push(to.meta.title)
  }
  document.title = title.reverse().join(' - ') + ' - 将来网'

  if (token) {
    // token有效，无用户信息或用户信息与token不匹配则重新获取用户信息
    if (!userInfo && to.meta.requireAuth) {
      httpV3
        .get('user/get/by/token?needThrowExp=false')
        .then(res => {
          if (Number(res.data.code) === 10000) {
            let userInfo = res.data.data
            userFormat(userInfo, to)
          } else {
            console.log('获取用户信息失败：' + res.data.msg)
            // 是否需要登录
            if (to.meta.requireAuth) {
              // 跳转登录页
              window.location.href = '/login?redirect=' + to.path
            } else {
              // window.localStorage.setItem('userInfo', "")
              delCookie('userInfo')
              store.commit('updateUserInfo', '')
              store.commit('updateCompany', '')
              store.commit('updateCompanyId', '')
            }
          }
        })
        .catch(err => {})
    } else if (userInfo && Number(userInfo.platformCategory) === 10) {
      alert('非后台用户，跳转前台')
      // 非后台用户，需要跳转前台
      window.location.href = appConfig.API.LOGIN_URL
    }
  }

  // 是否需要验证登录
  if (to.meta.requireAuth) {
    // 是否已有token
    if (token) {
      next()
    } else {
      console.log('未获取到token')
      if (to.meta.requireAuth) {
        // 跳转登录页
        window.location.href = '/login?redirect=' + to.path
      } else {
        store.commit('updateUserInfo', '')
        store.commit('updateCompany', '')
        store.commit('updateCompanyId', '')
      }
      // next();
    }
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js